import { Spinner } from '@phosphor-icons/react';

export default Spinner;
